<template>
  <div>
    <div class="float-right text-right" v-if="subscription.pricing.enabled">
      <div class="text-h6 text--primary">{{ $helpers.present.currency(subscription.monthlyPriceNoTax) }} {{ $t('prices.without-taxes') }} / {{ $t('dates.months') }}  </div>
      <small class="grey--text text--darken-1" v-if="subscription.yearly">
        ({{ $helpers.present.currency(subscription.yearlyPriceNoTax) }} {{ $t('prices.without-taxes') }} / {{ $t('dates.year') }})
        <br/>
      </small>

      <small v-if="subscription.coupon.id !== null" class="success--text">
        ( {{ $t('prices.discount') }}
        <span v-if="subscription.coupon.percentage">- {{ subscription.coupon.amount }}%</span>
        <span v-else>- {{ $helpers.present.currency(subscription.coupon.amount) }}</span>
        )
      </small>
    </div>
    <div class="text-h5">
      {{ $t('subscriptions.' + this.subscription.module + '.plans.' + this.subscription.plan).name }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanHeader',
  props: ['subscription'],
}
</script>